/*
Application Name: Practice Aid.
Application URI: https://practice-aid.com/
Description: PracticeAid is a group of professionals with collective expertise in medical and dental science, hospital administration and software development. These experts have come together to work on path-breaking solutions in Healthcare IT and deliver tangible value.
Version: 1.0.0
Author: Practice Aid.
Author URI: https://practice-aid.com/
 “M/s Totall Practice Aid Private Limited, CIN U72900MP2022PTC059139”
*/
import { postRequestWithToken } from "./helper"

export const addEducator = (data) => postRequestWithToken(data, 'admin/add-educator-message');

export const educatorList = (data) => postRequestWithToken(data, 'admin/educator-message-list');

export const educatorrequestList = (data) => postRequestWithToken(data, 'admin/educator-message-request-list');

export const updateEducator = (data) => postRequestWithToken(data, 'admin/update-educator-message');

export const changeEducatorStatus = (data) => postRequestWithToken(data, 'admin/change-educator-message-status');

export const uploadFile = (data) => postRequestWithToken(data, 'upload-file');